/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_Next_BookInputs */

const en_hero_next_book = /** @type {(inputs: Hero_Next_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book it`)
};

const pl_hero_next_book = /** @type {(inputs: Hero_Next_BookInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj`)
};

/**
* | output |
* | --- |
* | "Book it" |
*
* @param {Hero_Next_BookInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const hero_next_book = /** @type {((inputs?: Hero_Next_BookInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_Next_BookInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_hero_next_book(inputs)
	return en_hero_next_book(inputs)
});